import { useUpdateTicket } from "../hooks/useUpdateTicket";
import React from "react";
import moment from "moment";
import { getDisplayTitle } from "../utils/titleformat";
import { FaEdit } from "react-icons/fa";

const EditTicketModal = ({ ticket, ticketDetails, onClose, onSubmitSuccess, onError }) => {
  const { update, loading } = useUpdateTicket();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const form = e.target;
      const updated = await update({
        idTicket: ticket.idTicket,
        titre: form.titreTicketEdit.value,
        description: form.descriptionTicketEdit.value,
        priorite: parseInt(form.prioriteTicketEdit.value),
        idType: ticket.idType,
        dateDebut: moment(ticket.dateDebut).format("YYYY-MM-DD HH:mm").toString(),
        intervenant: (ticket.intervenant ?? []).map(i => i.idIntervenant),
      });
      if (updated) {
        onClose();
        onSubmitSuccess();
      } else {
        onError();
      }
    } catch (err) {
      // silent
    }
  };

  if (!ticketDetails) return null;

  const currentTitle = getDisplayTitle(ticket.titre).split("-");
  const shortTitle = currentTitle[currentTitle.length - 1].trim();

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div className="modal fade show d-block modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
        <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
          <div className="modal-content shadow-lg">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-light border-bottom">
                <div>
                  <h5 className="modal-title font-weight-bold">
                    <FaEdit className="me-2 text-warning" />
                    Modifier le ticket
                  </h5>
                  <small className="text-muted">{getDisplayTitle(ticket?.titre)}</small>
                </div>
                <button type="button" className="btn-close" onClick={onClose} aria-label="Fermer" />
              </div>

              <div className="modal-body">
                <div className="form-group">
                  <label className="font-weight-semibold">
                    Titre <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="titreTicketEdit"
                    name="titreTicketEdit"
                    placeholder="Titre..."
                    defaultValue={shortTitle}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="font-weight-semibold">Priorité</label>
                  <select
                    className="form-control"
                    name="prioriteTicketEdit"
                    defaultValue={ticket.priorite ?? 0}
                  >
                    <option value="0">Normal</option>
                    <option value="1">Urgent</option>
                  </select>
                </div>

                <div className="form-group mb-0">
                  <label className="font-weight-semibold">
                    Description <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    name="descriptionTicketEdit"
                    rows={5}
                    defaultValue={ticketDetails.description || ''}
                    placeholder="Description..."
                    required
                  />
                </div>
              </div>

              <div className="modal-footer bg-light border-top">
                <button type="button" className="btn btn-secondary" onClick={onClose}>
                  Annuler
                </button>
                <button
                  type="submit"
                  className="btn btn-warning text-white"
                  disabled={loading}
                >
                  {loading ? "Enregistrement..." : "Enregistrer"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditTicketModal;
